
import { defineComponent, PropType } from "vue";

import TrafficSignalLight from "./TrafficSignalLight.vue";
import TrafficSignalCounter from "./TrafficSignalCounter.vue";
import { DEFAULT_LIGHT_TYPE, LightType, LightTypes } from "../utils/constants";

export default defineComponent({
  name: "TrafficSignal",
  props: {
    activeLight: {
      type: String as PropType<LightType>,
      default: DEFAULT_LIGHT_TYPE
    }
  },
  data() {
    return {
      prevActiveLightIndex: 0,
      LightTypes,
      lights: [
        { type: LightTypes.RED, duration: 10000 },
        { type: LightTypes.YELLOW, duration: 3000 },
        { type: LightTypes.GREEN, duration: 15000 }
      ]
    };
  },
  computed: {
    activeLightIndex(): number {
      return this.lights.findIndex(light => light.type === this.activeLight);
    },
    activeLightDuration(): number {
      return this.lights[this.activeLightIndex].duration;
    }
  },
  methods: {
    checkIsLightActiveByIndex(index: number) {
      return this.activeLightIndex === index;
    },
    checkIsLightActiveByType(type: LightType) {
      return this.activeLight === type;
    },
    getNextActiveLightbyIndex(index: number) {
      return this.lights[index].type;
    },
    calcNextActiveLight() {
      let nextActiveLightIndex = this.activeLightIndex;

      if (this.checkIsLightActiveByType(LightTypes.RED)) {
        nextActiveLightIndex = this.activeLightIndex + 1;
      }

      if (this.checkIsLightActiveByType(LightTypes.GREEN)) {
        nextActiveLightIndex = this.activeLightIndex - 1;
      }

      if (this.checkIsLightActiveByType(LightTypes.YELLOW)) {
        nextActiveLightIndex =
          this.prevActiveLightIndex === 0
            ? this.activeLightIndex + 1
            : this.activeLightIndex - 1;
      }

      this.prevActiveLightIndex = this.activeLightIndex;

      return this.getNextActiveLightbyIndex(nextActiveLightIndex);
    }
  },
  components: {
    TrafficSignalLight,
    TrafficSignalCounter
  }
});
